export default "__VITE_ASSET__B$d10J48__"